import axios from "axios";

/*global BASE_URL */
// /*eslint no-undef: "error"*/
const API = axios.create({
  baseURL: BASE_URL,
  timeout: 120000,
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
  },
  mode: "no-cors",
});

// axios 1.x serialises FormData to JSON when Content-Type is application/json,
// which would drop file uploads. Unset it so the browser sends multipart with
// its own boundary (what axios 0.27 did).
API.interceptors.request.use((config) => {
  if (typeof FormData !== "undefined" && config.data instanceof FormData) {
    config.headers.delete("Content-Type");
  }
  return config;
});

export default API;
